export enum actionTypes {
  LOAD_GENERATORS_START = 'LOAD_GENERATORS_START',
  LOAD_GENERATORS_SUCCESS = 'LOAD_GENERATORS_SUCCESS',
  LOAD_REMAINING_GENERATOR_DETAIL_START = 'LOAD_REMAINING_GENERATOR_DETAIL_START',
  LOAD_REMAINING_GENERATOR_DETAIL_SUCCESS = 'LOAD_REMAINING_GENERATOR_DETAIL_SUCCESS',
  VALIDATION_START = 'VALIDATION_START',
  VALIDATION_SUCCESS = 'VALIDATION_SUCCESS',

  SAVE_GENERATOR_EDIT_CHANGES_START = 'SAVE_GENERATOR_EDIT_CHANGES_START',
  SAVE_GENERATOR_EDIT_CHANGES = 'SAVE_GENERATOR_EDIT_CHANGES',


  GENERATOR_FILTER_UPDATE = 'GENERATOR_FILTER_UPDATE',

  REFRESH_ACTIVE_NODE = 'REFRESH_ACTIVE_NODE',
  UPDATE_ACTIVE_NODE = 'UPDATE_ACTIVE_NODE',

  LOAD_PROFILE_START = 'LOAD_PROFILE_START',
  LOAD_PROFILE_SUCCESS = 'LOAD_PROFILE_SUCCESS',
  SWITCH_EDITOR_THEME = 'SWITCH_EDITOR_THEME',
  SWITCH_EDITOR_VIEW = 'SWITCH_EDITOR_VIEW',
  SWITCH_GENERATOR_VIEW = 'SWITCH_GENERATOR_VIEW',
  SWITCH_APP_LANGUAGE = 'SWITCH_APP_LANGUAGE',
  SWITCH_TOOLTIPS = 'SWITCH_TOOLTIPS',
  TOGGLE_LOGGING = 'TOGGLE_LOGGING',
  TOGGLE_DELETE_CONFIRMATION = 'TOGGLE_DELETE_CONFIRMATION',
  TOGLE_SHOW_LOG_INFO = 'TOGLE_SHOW_LOG_INFO',

  DELETE_GENERATOR_START = 'DELETE_GENERATOR_START',
  DELETE_GENERATOR_SUCCESS = 'DELETE_GENERATOR_SUCCESS',
}



// WEBPACK FOOTER //
// ./src/constants/actionTypes.ts